import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reusable-feedback-form',
  templateUrl: './reusable-feedback-form.component.html',
  styleUrls: ['./reusable-feedback-form.component.scss'],
})
export class ReusableFeedbackFormComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}







  // =================================== Feedback Form =========================================================

  
    // ==============Employee Feedback ===========================
    questions = [
      {
        id: 'Q1',
        question: 'How do you rate the work environment?',
        selected: 0, // will be updated by user
        ratings: [
          { value: 100, label: 'Bad' },
          { value: 200, label: 'Average' },
          { value: 300, label: 'Good' },
          { value: 400, label: 'Awesome' },
          { value: 500, label: 'Excellent' },
         
        ]
      },
      {
        id: 'Q2',
        question: 'How do you rate the leadership support?',
        selected: 0,
        ratings: [
          { value: 100, label: 'Poor' },
          { value: 2, label: 'Fair' },
          { value: 36, label: 'Good' },
          { value: 400, label: 'Very Good' },
          { value: 5, label: 'Outstanding' }
        ]
      }
    ];
  
    submitRatings() {
      const payload = this.questions.map(q => ({
        questionId: q.id,
        selected: q.selected
      }));
      console.log('Submitted Ratings:', payload);
  
     
    }
}
